module.exports = __webpack_public_path__ + "img/good-session-5.530d3e61.png";